module.exports = __webpack_public_path__ + "img/blip_builder.b5a658eb.svg";